export type Permission = 
  | 'dashboard.view'
  | 'appointments.view'
  | 'appointments.create'
  | 'appointments.edit'
  | 'patients.view'
  | 'patients.create'
  | 'patients.edit'
  | 'medical-records.view'
  | 'medical-records.create'
  | 'medical-records.edit'
  | 'prescriptions.view'
  | 'prescriptions.create'
  | 'prescriptions.edit'
  | 'billing.view'
  | 'billing.create'
  | 'billing.edit'
  | 'analytics.view'
  | 'messages.view'
  | 'users.view'
  | 'users.create'
  | 'users.edit'
  | 'settings.view'
  | 'settings.edit';

export type UserRole = 'Admin' | 'Doctor' | 'Nurse' | 'Receptionist' | 'Pharmacist';

export interface MenuItem {
  label: string;
  route: string;
  icon: string;
  permissions: Permission[];
  badge?: string;
  badgeColor?: string;
}

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  Admin: [
    'dashboard.view',
    'appointments.view',
    'appointments.create',
    'appointments.edit',
    'patients.view',
    'patients.create',
    'patients.edit',
    'medical-records.view',
    'medical-records.create',
    'medical-records.edit',
    'prescriptions.view',
    'prescriptions.create',
    'prescriptions.edit',
    'billing.view',
    'billing.create',
    'billing.edit',
    'analytics.view',
    'messages.view',
    'users.view',
    'users.create',
    'users.edit',
    'settings.view',
    'settings.edit'
  ],
  Doctor: [
    'dashboard.view',
    'appointments.view',
    'appointments.create',
    'appointments.edit',
    'patients.view',
    'patients.create',
    'patients.edit',
    'medical-records.view',
    'medical-records.create',
    'medical-records.edit',
    'prescriptions.view',
    'prescriptions.create',
    'prescriptions.edit',
    'messages.view',
       'billing.view',
    'billing.create',
    'billing.edit',
    'analytics.view',
    'messages.view',
    'users.view',
    'users.create',
    'users.edit',
    'settings.view',
    'settings.edit'
  ],
  Nurse: [
    'dashboard.view',
    'appointments.view',
    'patients.view',
    'patients.edit',
    'medical-records.view',
    'medical-records.create',
    'messages.view'
  ],
  Receptionist: [
    'dashboard.view',
    'appointments.view',
    'appointments.create',
    'appointments.edit',
    'patients.view',
    'patients.create',
    'patients.edit',
    'billing.view',
    'billing.create',
    'messages.view'
  ],
  Pharmacist: [
    'dashboard.view',
    'prescriptions.view',
    'prescriptions.edit',
    'billing.view',
    'messages.view'
  ]
};

export const MENU_ITEMS: MenuItem[] = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    permissions: ['dashboard.view']
  },
  {
    label: 'Appointments',
    route: '/appointments',
    icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
    permissions: ['appointments.view'],
    badge: 'Queue',
    badgeColor: 'bg-primary-100 text-primary-700'
  },
  {
    label: 'Patients',
    route: '/patients',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
    permissions: ['patients.view']
  },
  {
    label: 'Medical Records',
    route: '/medical-records',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    permissions: ['medical-records.view']
  },
  {
    label: 'Prescriptions',
    route: '/prescriptions',
    icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
    permissions: ['prescriptions.view']
  },
  {
    label: 'Billing',
    route: '/billing',
    icon: 'M9 7h6m0 10v-5m-5 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 9.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z',
    permissions: ['billing.view']
  },
  {
    label: 'Analytics',
    route: '/analytics',
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    permissions: ['analytics.view']
  },
  {
    label: 'Messages',
    route: '/messages',
    icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
    permissions: ['messages.view'],
    badge: '3',
    badgeColor: 'bg-red-500 text-white'
  },
  {
    label: 'Users',
    route: '/users',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z',
    permissions: ['users.view']
  },
  {
    label: 'Settings',
    route: '/settings',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z',
    permissions: ['settings.view']
  }
];

